import { jsx as e } from "react/jsx-runtime";
import { chakra as g, Box as h, useMultiStyleConfig as x } from "@chakra-ui/react";
import { useState as L, useEffect as P } from "react";
import n from "react-paginate";
import { NextLabel as y, PreviousLabel as B } from "./PaginationComponents.mjs";
const S = n.default ? n.default : n, w = ({ className: t, testId: a, ...o }) => /* @__PURE__ */ e(h, { "data-testid": a, children: /* @__PURE__ */ e(S, { containerClassName: t, ...o }) }), M = g(w, {
  shouldForwardProp: () => !0
}), C = ({
  itemsCount: t,
  itemsPerPage: a = 10,
  marginPagesDisplayed: o = 1,
  onPageClick: r,
  pageCount: f,
  pageRangeDisplayed: i = 3,
  testId: l,
  ...u
}) => {
  const c = x("Pagination"), [d, p] = L(0);
  P(() => {
    t && p(Math.ceil(t / a));
  }, [t, a]);
  const m = (s) => {
    const b = s.selected * a % t;
    r == null || r({ ...s, offset: b });
  };
  return /* @__PURE__ */ e(
    M,
    {
      sx: c.paginationBase,
      breakLabel: "...",
      nextLabel: /* @__PURE__ */ e(y, {}),
      previousLabel: /* @__PURE__ */ e(B, {}),
      onPageChange: m,
      pageRangeDisplayed: i,
      pageCount: f ?? d,
      marginPagesDisplayed: o,
      testId: l,
      ...u
    }
  );
};
export {
  C as TablePaginationBase
};
